import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
Alpine.plugin(collapse)

import { customModal, customModalLink } from '~/alpine/custom_modal'
Alpine.data('customModal', customModal)
Alpine.data('customModalLink', customModalLink)

import modalForm from '~/alpine/modal_form'
Alpine.data('modalForm', modalForm)

import { studentSearch, studentSort } from '~/alpine/student_search'
Alpine.data('studentSearch', studentSearch)
Alpine.data('studentSort', studentSort)

import { homepageHeader, passwordReset } from '~/alpine/homepage'
Alpine.data('homepageHeader', homepageHeader)
Alpine.data('passwordReset', passwordReset)

import registrationForm from '~/alpine/registration_form'
Alpine.data('registrationForm', registrationForm)

import { actionWithConfirmation } from '~/alpine/action_with_confirmation'
Alpine.data('actionWithConfirmation', actionWithConfirmation)

import toggle from '~/alpine/toggle'
Alpine.data('toggle', toggle)

import productPackage from '~/alpine/product_package'
Alpine.data('productPackage', productPackage)

import { inAppPurchaseSubject } from '~/alpine/in_app_purchase_subject'
Alpine.data('inAppPurchaseSubject', inAppPurchaseSubject)

import { subjectResults } from '~/alpine/subject_results'
Alpine.data('subjectResults', subjectResults)

import { nestedAttributes } from '~/alpine/nested_attributes'
Alpine.data('nestedAttributes', nestedAttributes)

import { imageUpload } from '~/alpine/image_upload'
Alpine.data('imageUpload', imageUpload)

import invoice from '~/alpine/invoice'
Alpine.data('invoice', invoice)

import liveCourse from '~/alpine/live_course'
Alpine.data('liveCourse', liveCourse)

import { courseTest, getCourseTest } from '~/alpine/course_test'
Alpine.data('courseTest', courseTest)
Alpine.data('getCourseTest', getCourseTest)

import creditInvoice from '~/alpine/credit_invoice'
Alpine.data('creditInvoice', creditInvoice)

import invoicePayments from '~/alpine/invoice_payments'
Alpine.data('invoicePayments', invoicePayments)

import paymentReminder from '~/alpine/payment_reminder'
Alpine.data('paymentReminder', paymentReminder)

import invoiceDeliveryMethods from '~/alpine/invoice_delivery_methods'
Alpine.data('invoiceDeliveryMethods', invoiceDeliveryMethods)

import { invoicesAndPayments, referenceTransactions, billingReports, reportsTable } from '~/alpine/billing'
Alpine.data('invoicesAndPayments', invoicesAndPayments)
Alpine.data('referenceTransactions', referenceTransactions)
Alpine.data('billingReports', billingReports)
Alpine.data('reportsTable', reportsTable)

import { itemsPerPage, PagyRemoteLink } from '~/alpine/pagination'
Alpine.data('itemsPerPage', itemsPerPage)
Alpine.bind('PagyRemoteLink', PagyRemoteLink)

import copyToClipboard from '~/alpine/copy_to_clipboard'
Alpine.data('copyToClipboard', copyToClipboard)

import { course } from '~/alpine/course'
Alpine.data('course', course)

import studentPurchasesContracts from '~/alpine/student_purchases_contracts'
Alpine.data('studentPurchasesContracts', studentPurchasesContracts)

import studentFeature from '~/alpine/student_feature'
Alpine.data('studentFeature', studentFeature)

import { flatpickrInput, dataTable } from '~/alpine/initializers'
Alpine.data('flatpickrInput', flatpickrInput)
Alpine.data('dataTable', dataTable)

import { searchForm } from '~/alpine/search_form'
Alpine.data('searchForm', searchForm)

import { courseOutline, studyModule, curriculumTrainings } from '~/alpine/course_outlines'
Alpine.data('courseOutline', courseOutline)
Alpine.data('studyModule', studyModule)
Alpine.data('curriculumTrainings', curriculumTrainings)

import { tableSort } from '~/alpine/table_sort'
Alpine.data('tableSort', tableSort)

import { teacherCalendar, studentCalendar } from '~/alpine/calendar'
Alpine.data('teacherCalendar', teacherCalendar)
Alpine.data('studentCalendar', studentCalendar)

import { navigation, subNavWrapper } from '~/alpine/navigation'
Alpine.data('navigation', navigation)
Alpine.data('subNavWrapper', subNavWrapper)

import cookieBanner from '~/alpine/cookie_banner'
Alpine.data('cookieBanner', cookieBanner)

import { characterCounter } from '~/alpine/character_counter'
Alpine.data('characterCounter', characterCounter)

import { customSelect } from '~/alpine/custom_select'
Alpine.data('customSelect', customSelect)

import { calendarEvent } from '~/alpine/calendar_event'
Alpine.data('calendarEvent', calendarEvent)

import { drivingSchoolSearch } from '~/alpine/driving_school_search'
Alpine.data('drivingSchoolSearch', drivingSchoolSearch)

import captcha from '~/alpine/captcha'
Alpine.data('captcha', captcha)

import { courseVideo } from '~/alpine/course_video'
Alpine.data('courseVideo', courseVideo)

window.Alpine = Alpine
window.Alpine.start()
